// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"Footer-module__footer-wrapper__w5A8x","footer":"Footer-module__footer__TpT4v","footer-flex":"Footer-module__footer-flex__WUVD5"};